import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "right flex-center"
};
import FooterBar from "@/components/FooterBar.vue";
export default {
  __name: 'AccountBg',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FooterBar)]);
    };
  }
};